const YearOfEducEnum = Object.freeze([
    {
        name: "1st Year 1st Semester",
        code: "FIRYR",
        id: 0,
    },
    {
        name: "1st Year 2nd Semester",
        code: "FIRYR",
        id: 0,
    }, {
        name: "2nd Year",
        code: "SECYR",
        id: 1,
    }, {
        name: "3rd Year",
        code: "THIRYR",
        id: 2,
    }, {
        name: "4th Year",
        code: "FORYR",
        id: 3,
    }, {
        name: "5th Year",
        code: "FIFYR",
        id: 4,
    }, {
        name: "6th Year",
        code: "SIXYR",
        id: 5,
    }, {
        name: "7th Year",
        code: "SEVYR",
        id: 6,
    }, {
        name: "8th Year",
        code: "EITYR",
        id: 7,
    }, {
        name: "9th Year",
        code: "NINYR",
        id: 8,
    }, {
        name: "10th Year",
        code: "TENYR",
        id: 9,
    }]);

export default YearOfEducEnum;